export default __webpack_public_path__ + "static/media/CAL42250.01bd897d.jpg";